<!--公共分页-->
<template>
  <div class="block" style="margin-top:10px">
    <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 100]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "pagination",
  components: {},
  props: ['pageNum','limit','total'],
  data() {
    return {
      //limit: 10,
     //pageNum:1,// 当前页码
      //total:0,//总条目数
    };
  },
  created() {

  },
  mounted() {},
  methods: {
    // 设置每页条数
    handleSizeChange(newSize) {
      this.$parent.handlePage(newSize)
      this.limit = newSize
      //this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.$parent.handlePage(null,newPage)
      //this.$emit('handleCurrentChange',newPage)
      this.pageNum = newPage
      //this.DataList()
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/view/common/pagination.vue